import { ReactSVG } from "react-svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from 'axios'
import { useState } from "react";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

type Props = {}

const RegisterExist = (props: Props) => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const email = searchParams.get("email")
    const [emailInput, setEmailInput] = useState(email || "")
    const [username, setUsername] = useState("")
    const [ic, setIc] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()

    const submitForm = async () => {
        localStorage.removeItem("token")
        localStorage.removeItem("user")
        localStorage.removeItem("selectedStudent")
        
        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/role`, {
            "name": username,
            "ic_number": ic,
            "email": emailInput.trim(),
            "password": password,
            "confirm_password": password,
            "role": "parent"
        }, { headers: {'Content-Type': 'application/json', "Accept":"application/json"}, withCredentials: true }).then( res => {
            setLoading(false)
            // console.log("res", res)
            console.log("res", res)
            if (res.status == 200) {
                // login user
                localStorage.setItem("user", JSON.stringify(res.data.data))
                localStorage.setItem("token", res.data.token)
                navigate("/profile")
            } else {
                toast.error("Error creating account")
            }
        }).catch( err => {
            console.log("err", err.response)
            setLoading(false)
            
            if (err.response && err.response.data.error) {
                toast.error(err.response.data.error)
            } else if (err.response && err.response.data) {
                for (let msgKey in err.response.data) {
                    toast.error(err.response.data[msgKey][0])
                }
            } else {
                toast.error(err.response ? err.response.data.error : "Error creating account")
            }
        })
    }


    return (
        <div style={{paddingTop:"2rem", paddingRight: "2rem", paddingLeft:"2rem", paddingBottom:"3rem", height:"100vh"}}>
            <div className="auth-page-header mb-3">
                <div className="container">
                    <img src={process.env.PUBLIC_URL + "/assets/img/koku.png"} className="img-fluid w-20" alt="" />
                    <h3 className="text-2xl self-center">{t('register_exist.register_as_parent')}</h3>
                </div>
            </div>

            <div className="auth-page-body">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="px-2 py-4 rounded-3xl">
                                <form>
                                    <div className="auth-form__single-field space-mb--30">
                                        <label>{t('register_exist.name')}</label>
                                        <input value={username} onChange={(e)=>setUsername(e.target.value)} type="text" name="name" id="name" placeholder={t('register_exist.enter_name')} />
                                    </div>
                                    <div className="auth-form__single-field space-mb--30">
                                        <label>{t('register_exist.ic')}</label>
                                        <input value={ic} onChange={(e)=>setIc(e.target.value)} type="number" name="emailAddress" id="emailAddress" placeholder={t('register_exist.enter_ic')} />
                                    </div>
                                    <div className="auth-form__single-field space-mb--30">
                                        <label>{t('register_exist.email')}</label>
                                        <input value={emailInput} onChange={(e)=>setEmailInput(e.target.value)} type="text" name="emailAddress" id="emailAddress" placeholder={t('register_exist.enter_email')}/>
                                    </div>
                                    <div className="auth-form__single-field space-mb--30">
                                        <label>{t('register_exist.password')}</label>
                                        <input value={password} onChange={(e)=>setPassword(e.target.value)} type="password" name="password" id="password" placeholder={t('register_exist.enter_password')}/>
                                    </div>
                                    <div className="auth-form__single-field mb-6">
                                        <p className="auth-form__info-text">{t('register_exist.already_have_account')}{" "} <Link to={"/login"}>{t('register_exist.sign_in_now')}</Link> </p>
                                    </div>
                                    <button type="button" className="text-white text-[16px] leading-none w-full py-[15px] bg-theme border-none rounded-3xl flex items-center justify-center" onClick={()=>submitForm()}>
                                    {loading ? (<FaSpinner className="animate-spin"/>) : t('register_exist.create_parent_account')}
                                    </button>
                                    
                                    <div className="row w-3/6 my-4 px-2 float-right">
                                        <select className="px-2 py-1 border rounded-full text-md bg-white focus:outline-none focus:ring-2 focus:ring-theme appearance-none" onChange={(e) => { i18next.changeLanguage(e.target.value) }}>
                                            <option value="-1" selected disabled>-- Language --</option>
                                            <option value="en">English</option>
                                            <option value="zh">Mandarin</option>
                                            <option value="ms">Bahasa</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RegisterExist